import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {VehicleCreate} from '../../shared/models/vehicle.model';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-vehicle',
    templateUrl: 'form-vehicle.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormVehicleComponent implements OnInit, OnDestroy {

    private unsubscribe$: Subject<void> = new Subject<void>();
    vehicleForm: FormGroup;

    constructor(private dataStorageService: DataStorageService) {
    }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.vehicleForm = new FormGroup({
            'model': new FormControl(),
            'vin': new FormControl(),
            'capacity': new FormControl()
        });
    }

    onAddRoute() {
        const value = this.vehicleForm.value;
        const newVehicle = new VehicleCreate(value.model, value.vin, value.capacity);
        this.dataStorageService.createVehicle(newVehicle)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                if (responseData['error']) {
                    console.log('saving vehicle month error');
                } else {
                    alert('vehicle added. ');
                    location.reload();
                }
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
